<ag-grid-angular
    style="width: 100%; height: calc(100vh - 110px);"
    class="ag-theme-alpine"
    [gridOptions]="app_gridoptions"
    [animateRows]="true"
    [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef"
    [allowContextMenuWithControlKey]="true"
    [getContextMenuItems]="getContextMenuItems"
    [rowData]="rowData"
    [pagination]="true"
    [paginationPageSize]="20"
    [enableRangeSelection]="true"
    [suppressNoRowsOverlay]="true"
    [loadingCellRendererParams]="loadingCellRendererParams"
    (gridReady)="onGridReady($event)"
   >
  </ag-grid-angular>

